import { LOCATION_CHANGE } from 'connected-react-router'

import getRouteName from '../utils/routeNames'

export default function hotelsAndGroups(
  state = {
    title: '',
    subtitle: '',
    width: 1000,
    isFixed: false,
    documentTitle: 'Directful Dashboard'
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_HEADER_TITLES':
      return {
        ...state,
        title: action.payload.title,
        subtitle: action.payload.subtitle,
        width: action.payload.width,
        isFixed: action.payload.isFixed
      }

    case 'CLEAR_HEADER_TITLES':
      return {
        ...state,
        title: null,
        subtitle: null,
        width: null,
        isFixed: false
      }

    case LOCATION_CHANGE:
      return { ...state, documentTitle: getRouteName(action.payload.location.pathname) }

    default:
      return state
  }
}
